import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class DPReportRequest {
    @ApiProperty()
    unitId?: number;
    @ApiProperty()
    zoneId?: number;
    @ApiProperty()
    masterBrandId?: number;
    @ApiProperty()
    skuCodeId?: number;
    @ApiProperty()
    shift?: any;
    @ApiProperty()
    stockType?: string;
    @ApiProperty()
    fromDate?: string;
    @ApiProperty()
    toDate?: string;
    @ApiProperty()
    foodTypeId?:number

}